import { Logout01Icon } from '@hugeicons/core-free-icons';
import { Avatar, AvatarFallback } from '../ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { HugeIcon } from '../ui/HugeIcon';

function initials(name: string) {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]?.toUpperCase()).join('') || 'U';
}

export function HeaderUserMenu({ currentUser, logoutHref }: {
  currentUser: { email: string; fullName: string };
  logoutHref: string;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={`Open account menu for ${currentUser.fullName}`}
        className="rounded-full outline-none focus-visible:ring-3 focus-visible:ring-ring/30"
      >
        <Avatar className="size-9 bg-slate-900 shadow-[0_1px_3px_rgba(15,23,42,0.18)]">
          <AvatarFallback className="bg-slate-900 text-xs font-semibold text-white">{initials(currentUser.fullName)}</AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60" sideOffset={8}>
        <DropdownMenuGroup>
          <DropdownMenuLabel className="px-2 py-2">
            <span className="block truncate text-sm font-semibold text-foreground">{currentUser.fullName}</span>
            <span className="block truncate text-xs font-normal text-muted-foreground">{currentUser.email}</span>
          </DropdownMenuLabel>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => { window.location.href = logoutHref; }} variant="destructive">
          <HugeIcon icon={Logout01Icon} size={16} />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
